export const TakingMedicineRecord = {
  Title: {
    TakingMedicineForToday: '本日アラームがセットされているお薬',
    Calendar: 'お薬カレンダー',
  },
  Text: {
    NotHavingTakingMedicine: 'アラームがセットされているお薬はありません。',
  },
  Button: {
    Done: '服薬済',
    Plan: '服薬予定あり',
    NoPlan: '予定なし',
    AddAlerm: '服薬アラームを設定する',
    DisplayList: 'アラーム一覧を表示する',
  },
};
